import type { CatDocStateTagEnum } from './cat.model';

export const REEVAL_JOBS_STORAGE_KEY = 'scai.reevalJobs.v1';

export type ReevalJobKind = 'REV' | 'CAT';

/** Identifies the tile a background re-evaluation belongs to. */
export interface ReevalJobTarget {
  kind: ReevalJobKind;
  docId: number;
  /** REV: phraseId, or imageId when isImage. CAT: IndElement.elementId. */
  elementId: number;
  isImage: boolean;
  /** CAT only: CatDocStateTagEnum.PRIME or CatDocStateTagEnum.SEC. */
  stateTag?: CatDocStateTagEnum;
}

/** Plain JSON: persisted to sessionStorage. */
export interface ReevalJob {
  runNum: number;
  target: ReevalJobTarget;
  createdAt: number;
}

export function reevalTargetKey(target: ReevalJobTarget): string {
  return `${target.kind}:${target.docId}:${target.isImage ? 'I' : 'P'}:${target.elementId}`;
}
